let active = false

const toggler = document.querySelector('.sidebar-nav-child > li > .nav-item')
const togglee = document.querySelector('.sidebar-nav-dropdown')

if (toggler && togglee) {
	toggler.addEventListener('click', (event) => {
		event.preventDefault()
		active = !active
		togglee.classList[active ? 'remove' : 'add']('collapse')
	})
}
